<template>
  <div id="Home">
    <div class="topbar">
      <div class="left">
        <img src="../assets/icon_topbar_01.png" style="vertical-align:middle;" />
        <span class="versionId">专业版</span>
      </div>
      <div class="right">
        <!-- <div class="switch" @click="toggleLang">
          <div class="itm" :class="i18n == 'cn' ? '' : 'act'">中文</div>
          &nbsp;&nbsp;|&nbsp;&nbsp;
          <div class="itm" :class="i18n == 'en' ? '' : 'act'">English</div>
        </div> -->
        <div class="bell"></div>
        <el-dropdown placement="bottom" @command="handleCommand">
          <div class="account">
            <img :src="account.photo || normalUrl" alt="" class="img" />
            <div class="pname">{{ account.nickname }}</div>
            <span class="icon-nav-more"></span>
          </div>
          <!-- <span class="el-dropdown-link">
            下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
          </span> -->
          <el-dropdown-menu slot="dropdown">
            <!--<el-dropdown-item command="a">更新缓存</el-dropdown-item>-->
            <el-dropdown-item command="b" @click.native="onSafe">重置密码</el-dropdown-item>
            <el-dropdown-item command="c">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <FormDialog ref="dialog" :title="title" :width="'548px'" :labelWidth="'110px'" :rules="rules" :form="mform"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
    <!--左侧-->
    <el-menu class="el-menu-vertical" @open="handleOpen" @close="handleClose" text-color="#909399"
      active-text-color="#fff" :unique-opened="true" :router="true" :default-active="menuIndex">
      <div v-for="(item, i) in nav_menu" :key="i">
        <el-menu-item v-if="!item.children" :index="item.value" :class="[menuIndex === item.value ? 'active' : '']">
          <img :src="item.src" width="16" />
          <span slot="title">{{ i18n == 'cn' ? item.name : (item.enname || item.name) }}</span>
        </el-menu-item>
        <el-menu-item v-else-if="item.children && item.children == 1">
          <img :src="item.children[0].src" />
          <span slot="title">{{ item.children[0].name }}</span>
        </el-menu-item>
        <el-submenu v-else :index="item.value">
          <template slot="title">
            <!--<i class="el-icon-location"></i>-->
            <img :src="item.src" />
            <span>{{ i18n == 'cn' ? item.name : (item.enname || item.name) }}</span>
          </template>
          <el-menu-item-group v-for="(sub, ind) in item.children" :key="ind">
            <el-menu-item :index="sub.value" :class="[menuIndex === sub.value ? 'active' : '']">{{ sub.name }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>

    <div class="main-section">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import paths from "../config/paths";

export default {
  name: "Home",
  data() {
    return {
      i18n: 'cn',
      systit: "风谷车队",
      pname: "管理员",
      account: { nickname: "未登录" },
      normalUrl: require("@/assets/img/logo.jpg"),
      menuIndex: "",
      title: '重置密码',
      viewMode: false,
      mform: {
        ypassword: '',
        password: '',
        passwords: '',
      },
      mformCtrl: [
        {
          label: "用户名",
          keyName: "username",
          err: "请填写用户名",
          type: "text",
          disabled: true,
        },
        {
          label: "原密码",
          keyName: "ypassword",
          err: "请填写密码",
          type: "password",
          disabled: true,
        },
        {
          label: "新密码",
          keyName: "password",
          err: "请填写新密码",
          type: "password",
        },
        {
          label: "确认密码",
          keyName: "passwords",
          err: "请确认密码",
          type: "password",
        },
      ],
      rules: {
        ypassword: [
          { required: true, message: "请填写原密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写新密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
        passwords: [
          { required: true, validator: this.checkPwds, trigger: "blur" },
          // { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      paths,
      baseUrl: 'index',
      nav_menu: [],
    };
  },
  computed: {
    ...mapState([
      'IP',
      'user',
    ]),
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    toggleLang() {
      if (this.i18n == 'cn') {
        this.i18n = 'en'
      } else if (this.i18n == 'en') {
        this.i18n = 'cn'
      }
    },
    checkPwds(rule, value, callback) {
      console.log(rule, value)
      if (value == undefined || value == '') {
        callback(new Error('请确认密码'));
      } else if (this.mform.password !== value) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    matchPath() {
      const path = this.$route.path;
      // console.log('$route', this.$route);
      // console.log('path', path);
      // 默认当前路由高亮，无字路由
      this.menuIndex = path
      // console.log('menuIndex', this.menuIndex)
      for (const key in this.paths) {
        if (Object.hasOwnProperty.call(this.paths, key)) {
          // console.log(key, path)
          if (key === path || this.paths[key].includes(path) || path.includes(key)) {
            // console.log(key, path)
            this.menuIndex = key
          }
        }
      }
      // console.log('menuIndex', this.menuIndex)

      // 匹配当前路由，遍历子路由，覆盖索引值
      // console.log('navMenu', this.navMenu);
      const object = this.navMenu
      for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
          const element = object[key];
          if (path.includes(element.value)) {
            // console.log({ ...element })
            if (element.children && element.children.length) {
              element.children.map(v => {
                if (path.includes(v.value)) {
                  this.menuIndex = v.value
                }
              })
            }
          }
        }
      }

      const query = this.$route.query
      const arr = []
      for (const key in query) {
        if (Object.hasOwnProperty.call(query, key)) {
          arr.push(`${key}=${query[key]}`)
        }
      }
      if (arr.length) {
        // this.menuIndex += '?' + arr.join('&')
        // console.log(this.menuIndex)
      }
    },
    logout() {
      this.setUserInfo({})
      this.$router.replace("/login");
    },
    handleCommand(command) {
      if (command === "c") {
        this.logout();
      }
    },
    showDialog(str = 'dialog') {
      this.$refs[str] && this.$refs[str].show()
    },
    hideDialog(str = 'dialog') {
      typeof str == 'string' ? null : str = 'dialog'
      this.$refs[str] && this.$refs[str].hide()
    },
    //安全管理
    onSafe() {
      if (this.user && this.user.username) {
        this.mform['username'] = this.user.username
      }
      this.showDialog()
    },
    onModalSubmit() {
      this.loading = true
      let url = `${this.baseUrl}/meperson`;
      const params = {
        ...this.mform,
        id: this.user.id
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '密码修改成功!',
          });
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '修改失败，请稍后重试！'
        });
      })
    },
    setNav() {
      const { user_group_id } = this.user
      const { id } = this.user
      // console.log('user_group_id', user_group_id)
      /* 1.车队经理
      2.主管会计
      3.分管会计
      4.出纳
      5.车队长
      6.机务
      7.车务
      8.人力
      9.司机
      10.押运员
      11.副队长
      12.客户
      13.维修商
       */
      if (user_group_id == 1) {
        // 超级管理员
        this.nav_menu = [...this.navMenu]
        if (id != 1) {
          this.nav_menu.map(v => {
            const { name, children } = v
            if (name === '人员管理') {
              // console.log(children)
              v.children = children.filter(o => !['车队经理管理'].includes(o.name))
            }
          })
        }
      } else if ([2, 3, 4].includes(user_group_id)) {
        // 主管会计、分管会计、出纳不显示以下板块
        this.navMenu.map(v => {
          if (
            ['运单管理', '合同管理', '客户管理', '车辆管理', '承运管理', '维保管理', '考勤管理', '财务管理', '系统设置'].includes(v.name)
          ) {
            this.nav_menu.push({ ...v })
          }
        })
        this.nav_menu.map(v => {
          const { name, children } = v
          if (name === '运单管理') {
            // console.log(children)
            v.children = children.filter(o => !['运单回收站'].includes(o.name))
          } else if (name === '车辆管理') {
            // console.log(children)
            v.children = children.filter(o => !['自有车辆', '外协车辆', '挂车管理', '车队分组', '临期查询'].includes(o.name))
          } else if (name === '维保管理') {
            // console.log(children)
            v.children = children.filter(o => !['维保类型配置'].includes(o.name))
          } else if (name === '人员管理') {
            // console.log(children)
            v.children = children.filter(o => ['打短司机管理', '打短押运管理'].includes(o.name))
          } else if (name === '系统设置') {
            // console.log(children)
            v.children = children.filter(o => ['工资提成设置', '固定费用配置', '出车费用配置', '附加费用配置', '油气站配置'].includes(o.name))
          }
        })
      } else if (user_group_id == 5) {
        // 车队长去除无权限的导航
        this.navMenu.map(v => {
          if (
            ['车辆定位', '报单管理', '运单管理', '合同管理', '客户管理', '车辆管理', '承运管理', '车辆管理', '维保管理', '人员管理', '财务管理', '考勤管理', '系统设置'].includes(v.name)
          ) {
            this.nav_menu.push({ ...v })
          }
        })
        this.nav_menu.map(v => {
          const { name, children } = v
          // console.log(children)
          if (name === '运单管理') {
            v.children = children.filter(o => !['运单补差', '运单回收站'].includes(o.name))
          } else if (name === '合同管理') {
            v.children = children.filter(o => !['合同补差'].includes(o.name))
          } else if (name === '车辆管理') {
            v.children = children.filter(o => !['车队分组'].includes(o.name))
          } else if (name === '人员管理') {
            v.children = children.filter(o => !['车队经理管理', '主管会计管理', '分管会计管理', '会计管理', '出纳管理', '车队长管理', '副队长管理', '机务管理', '车务管理'].includes(o.name))
          } else if (name === '财务管理') {
            // console.log(children)
            v.children = children.filter(o => !['预支款管理', '固定费用配置', '出车费用配置', '油气费汇总表', '承运利润表', '车队利润表', '车队长工资表', '月度分析表', '工资提成设置', '车队长预计工资', '月度统计表'].includes(o.name))
          } else if (name === '系统设置') {
            // console.log(children)
            v.children = children.filter(o => ['货物配置'].includes(o.name))
          }
        })
      } else if (user_group_id == 6) {
        // 机务
        // 只有维保管理模块权限
        this.navMenu.map(v => {
          if (
            ['车辆管理', '维保管理', '系统设置'].includes(v.name)
          ) {
            this.nav_menu.push({ ...v })
          }
        })
        this.nav_menu.map(v => {
          const { name, children } = v
          if (name === '车辆管理') {
            // console.log(children)
            v.children = children.filter(o => !['外协车辆', '车队分组', '临期查询'].includes(o.name))
          } else if (name === '系统设置') {
            // console.log(children)
            v.children = children.filter(o => ['维保类型配置'].includes(o.name))
          }
        })
      } else if (user_group_id == 7) {
        // 车务
        this.navMenu.map(v => {
          if (
            ['车辆管理', '承运管理', '人员管理', '系统设置'].includes(v.name)
          ) {
            this.nav_menu.push({ ...v })
          }
        })
        this.nav_menu.map(v => {
          const { name, children } = v
          if (name === '人员管理') {
            // console.log(children)
            v.children = children.filter(o => ['司机管理', '押运员管理'].includes(o.name))
          } else if (name === '车辆管理') {
            v.children = children.filter(o => !['车队分组'].includes(o.name))
          } else if (name === '承运管理') {
            v.children = children.filter(o => ['外协车辆'].includes(o.name))
          } else if (name === '系统设置') {
            // console.log(children)
            v.children = children.filter(o => ['车辆类型配置', '车辆保险配置', '车辆证件配置'].includes(o.name))
          }
        })
      } else if (user_group_id == 12) {
        // 客户
        // 报单管理
        // this.nav_menu.push({
        //   name: '报单管理',
        //   enname: 'Report Order',
        //   src: require('@/assets/icon_navleft_01.png'),
        //   value: '/customer/CReportOrder',
        // })
        this.navMenu.map(v => {
          if (
            ['报单管理', '运单管理', '财务管理'].includes(v.name)
          ) {
            const c = { ...v }
            if (c.name === '财务管理') {
              delete c.children
              c.value = '/finance/clist'
            } else if (c.name === '运单管理') {
              delete c.children
              c.enname = 'Custom Order'
              c.value = '/cOrder/list'
            }

            this.nav_menu.push(c)
          }
        })
        this.nav_menu.map(v => {
          const { name, children } = v
          if (name === '报单管理') {
            // console.log(children)
            // v.children = children.filter(o => ['司机管理', '押运员管理'].includes(o.name))
            v.children = children.map(o => {
              const c = { ...o }
              if (o.name === '报单列表') {
                c.value = '/reportOrder/clist'
              }
              return c
            })
            v.children.push({
              name: '报单回收站',
              value: '/reportOrder/recyclelist',
            })
          }
        })
        console.log([...this.nav_menu])
      } else if (user_group_id == 13) {
        // 维修商
        this.navMenu.map(v => {
          if (v.name == '维保管理') {
            console.log({ ...v })
            const {
              enname,
              name,
              src,
            } = v
            const o = {
              enname,
              name,
              src,
              value: '/fix/repairlist'
            }
            this.nav_menu.push(o)
          } else if (v.name == '财务管理') {
            const {
              enname,
              name,
              src,
            } = v
            const o = {
              enname,
              name,
              src,
              value: '/fix/payment'
            }
            this.nav_menu.push(o)
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: '没有登陆权限！',
        });
        this.logout()
      }
      // console.log(this.navMenu)
      // console.log(this.nav_menu)
      this.matchPath();
    },
    checkLogin() {
      // 本地调试不调用
      if (location.host.includes('localhost')) return
      const url = `/login/verifyAccessToken`
      const params = {
        userid: this.user.id,
        access_token: this.user.access_token,
      }
      this.post(url, params, ({ msg }) => {
        if (msg !== 'success') {
          this.$message({
            type: 'error',
            message: msg,
          });
          this.logout()
        }
      }, err => {
        console.log(err)
      })
    },
  },
  watch: {
    $route(to, from) {
      this.fromPath = from.path;
      this.matchPath();
      this.checkLogin()

      // if (to.fullPath.includes('?')) {
      //   console.log(from.fullPath, to.fullPath)

      // }
    },
  },
  created() {
    // console.log([...this.navMenu])
    if (this.user && this.user.id) {
      console.log('user', { ...this.user })
      this.account = { ...this.user }
      this.setNav()
      this.$forceUpdate()
    } else {
      this.$router.replace('/login')
    }
  },
  mounted() {
    this.checkLogin()
  },
};
</script>

<style lang="less">
#app {
  background: #f6f7f9;
}

#Home {
  position: relative;
  height: 100vh;
  overflow: hidden;

  .topbar {
    position: absolute;
    left: 0;
    right: 0;
    background-color: #fff;
    height: 66px;
    line-height: 66px;

    .left {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 22px;
      color: #343434;
      position: absolute;
      left: 20px;
      top: 13px;
      font-weight: 700;
      letter-spacing: 1px;

      .versionId {
        width: 60px;
        height: 23px;
        line-height: 22px;
        text-align: center;
        overflow: hidden;
        margin: 0 5px 0 6px;
        border-radius: 15px;
        font-family: "Microsoft YaHei";
        font-size: 13px;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.6);
        background: linear-gradient(205deg, #65F4FF 0%, #65F4FF 1%, #3E82FE 100%);
      }

      .versionLe {
        height: 23px;
        line-height: 23px;
        text-align: center;
        overflow: hidden;
        font-family: "DingTalk JinBuTi-Regular";
        text-transform: capitalize;
        font-size: 15px;
        color: #606266;
      }
    }

    .right {
      position: absolute;
      right: 0;
      padding: 0 20px;
      display: flex;

      .switch {
        display: flex;

        .act {
          color: #1182fb;
          cursor: pointer;
        }
      }

      .account {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        position: relative;
        cursor: pointer;

        .img {
          width: 30px;
          height: 30px;
          margin-right: 12px;
          border-radius: 50%;
        }

        .pname {
          color: #3c4353;
        }

        .icon-nav-more {
          width: 0;
          height: 0;
          border-style: solid dashed dashed;
          border-color: #fff transparent transparent;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.2s;
          -webkit-transition: all 0.2s;
          position: absolute;
          top: 50%;
          right: 3px;
          margin-top: -3px;
          border-width: 6px;
          border-top-color: #a6aab8;
        }

        &:hover .icon-nav-more {
          margin-top: -9px;
          border-style: dashed dashed solid;
          border-color: transparent transparent #a6aab8;
        }
      }
    }
  }

  .el-menu-vertical {
    width: 200px;
    position: absolute;
    top: 66px;
    left: 0;
    bottom: 0;
    background-color: #303133;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    .el-menu-item {

      &:hover,
      &:focus,
      &.active {
        background: #1182fb;
        color: #fff !important;
      }

      * {
        margin-right: 10px;
      }
    }

    .el-submenu {
      .el-submenu__title {
        &:hover {
          background: #1182fb;
          color: #fff !important;
        }

        * {
          margin-right: 10px;
        }

        img {
          width: 16px;
        }
      }

      .el-menu-item-group__title {
        padding: 0;
      }

      .el-menu--inline {
        background: #293746;
      }

      .el-menu-item {
        &.active {
          background: #1182fb;
        }
      }
    }
  }

  .main-section {
    margin: 66px 0 0 200px;
    width: calc(100vw - 200px);
    height: calc(100vh - 66px);
    overflow: auto;
    overflow-x: hidden;
    padding: 20px;
    padding: 0;
    box-sizing: border-box;
    border-top: 1px solid #dde2ee;

    >div,
    >.main {
      margin: 20px;
      min-height: calc(100vh - 107px);
    }
  }
}
</style>
